<template>
  <div class="view-normal">
    <slot name="user"></slot>
    <slot name="title"></slot>
    <section-tags :link-info="linkInfo" show-special-tag></section-tags>
    <section-lottery :link-info="linkInfo"></section-lottery>
    <slot name="content"></slot>
    <section-vote :link-info="linkInfo"></section-vote>
    <slot name="tag"></slot>
  </div>
</template>

<script>
import SectionLottery from '../sections/section-lottery.vue'
import SectionVote from '../sections/section-vote.vue'
import SectionTags from '../sections/section-tags.vue'
export default {
  components: {
    SectionVote,
    SectionLottery,
    SectionTags
  },
  props: {
    linkInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      vote_data: null
    }
  },
  created () {
    this.handleData()
  },
  methods: {
    handleData () {
      this.vote_data = this.linkInfo.vote_info
    }
  }
}
</script>

<style>

</style>